export default function VeryViralVideos() {
  return (
    <div className="relative">
      <div className="h-screen lg:h-[900px] xl:h-screen 4xl:h-[900px] py-6 lg:py-12 4xl:max-w-[100rem] min-w-full 4xl:min-w-fit 4xl:mx-auto relative">
        <div className="flex justify-center items-center h-full">
          <div className="flex flex-col lg:flex-row gap-5 z-40">
            <h1 className="text-4xl xs:text-5xl lg:text-7xl vvv-font font-bold">
              <span className="text-primary">V</span>ERY
            </h1>
            <h1 className="text-4xl xs:text-5xl lg:text-7xl vvv-font font-bold">
              <span className="text-primary">V</span>IRAL
            </h1>
            <h1 className="text-4xl xs:text-5xl lg:text-7xl vvv-font font-bold">
              <span className="text-primary">V</span>IDEOS
            </h1>
          </div>
        </div>

        <div
          className="absolute left-4 lg:left-14 top-36 lg:top-14 rounded-full h-28 xs:h-40 md:h-52 w-28 xs:w-40 md:w-52 video-float"
          style={{ animationDelay: "0s" }}
        >
          <video
            preload="metadata"
            loading="lazy"
            autoPlay
            muted
            loop
            playsInline
            className="video rounded-full"
          >
            <source
              src="https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/vvv/panda.mp4"
              type="video/mp4"
            />
          </video>
        </div>

        <div className="absolute top-10 w-full hidden lg:flex justify-center items-start gap-4">
          <div
            className="relative rounded-full h-28 w-28 overflow-hidden flex-shrink-0 mt-auto video-float"
            style={{ top: "3rem", animationDelay: "0.2s" }}
          >
            <video
              preload="metadata"
              loading="lazy"
              autoPlay
              muted
              loop
              playsInline
              className="w-full h-full object-cover rounded-full"
            >
              <source
                src="https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/vvv/parachute.mp4"
                type="video/mp4"
              />
            </video>
          </div>
          <div
            className="relative rounded-full h-40 w-40 overflow-hidden flex-shrink-0 video-float"
            style={{ top: "1rem", animationDelay: "0.4s" }}
          >
            <video
              preload="metadata"
              loading="lazy"
              autoPlay
              muted
              loop
              playsInline
              className="w-full h-full object-cover rounded-full"
            >
              <source
                src="https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/vvv/mini-penguin.mp4"
                type="video/mp4"
              />
            </video>
          </div>
        </div>

        <div
          className="absolute right-4 -top-10 lg:-top-16 rounded-full h-52 md:h-96 w-52 md:w-96 lg:w-72 lg:h-72 xl:w-96 xl:h-96 video-float"
          style={{ animationDelay: "0.6s" }}
        >
          <video
            preload="metadata"
            loading="lazy"
            autoPlay
            muted
            loop
            playsInline
            className="video rounded-full"
          >
            <source
              src="https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/vvv/clown-dance.mp4"
              type="video/mp4"
            />
          </video>
        </div>

        <div
          className="absolute left-4 -bottom-10 lg:-bottom-16 rounded-full h-52 md:h-96 w-52 md:w-96  lg:w-72 lg:h-72 xl:w-96 xl:h-96 video-float"
          style={{ animationDelay: "0.8s" }}
        >
          <video
            preload="metadata"
            loading="lazy"
            autoPlay
            muted
            loop
            playsInline
            className="video rounded-full"
          >
            <source
              src="https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/vvv/dance.mp4"
              type="video/mp4"
            />
          </video>
        </div>

        <div className="absolute bottom-24 w-full hidden lg:flex justify-center gap-20">
          <div
            className="relative rounded-full h-36 w-36 overflow-hidden flex-shrink-0 video-float"
            style={{ top: "3rem", animationDelay: "1s" }}
          >
            <video
              preload="metadata"
              loading="lazy"
              autoPlay
              muted
              loop
              playsInline
              className="w-full h-full object-cover rounded-full"
            >
              <source
                src="https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/vvv/balloon-prank.mp4"
                type="video/mp4"
              />
            </video>
          </div>
          <div
            className="relative rounded-full h-24 w-24 overflow-hidden flex-shrink-0 !-mt-4 video-float"
            style={{ top: "1rem", animationDelay: "1.2s" }}
          >
            <video
              preload="metadata"
              loading="lazy"
              autoPlay
              muted
              loop
              playsInline
              className="w-full h-full object-cover rounded-full"
            >
              <source
                src="https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/vvv/skiing.mp4"
                type="video/mp4"
              />
            </video>
          </div>
        </div>

        <div
          className="absolute right-4 lg:right-20 bottom-28 xs:bottom-32 lg:-bottom-12 rounded-full h-28 xs:h-32 md:h-60 w-28 xs:w-32 md:w-60 video-float"
          style={{ animationDelay: "1.4s" }}
        >
          <video
            preload="metadata"
            loading="lazy"
            autoPlay
            muted
            loop
            playsInline
            className="video rounded-full"
          >
            <source
              src="https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/vvv/skate-board.mp4"
              type="video/mp4"
            />
          </video>
        </div>
      </div>
    </div>
  );
}
